import { getObjectValue } from '@services/object-extensions';
import cn from 'classnames';
import { useState } from 'react';
import { GenericSlider } from '@components/common/carousel/generic-slider';
import { Navbar } from '@components/common/navbar/navbar';
import { useIntl } from 'react-intl';
import { PageHead } from '@components/common/head/page-head';
import { Link } from 'react-router-dom';
import styles from './dettaglio.module.css';
import SVG from '@svg/arrow-right.svg';
import { Card } from '../card/card';
import { AdditionalContentAccordionGroup } from '../../common/additional-content-accordion-group/additional-content-accordion-group';
import { ScrollToTop } from '../scroll-to-top/scroll-to-top';

const Dettaglio = ({
  translations = {},
  darkTheme = false,
  imageUrl = '',
  serviceCategories = [],
  technologyCategories = [],
  link = {}
}) => {
  const [visibleSlideNumber, setVisibleSlideNumber] = useState(0);
  const mappedSlides = getObjectValue(translations, 'card', [])?.map((element) => (
    <Card translations={element} />
  ));

  const intl = useIntl();

  const backgroundImage = imageUrl
    ? `${darkTheme ? 'linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.6)), ' : ''}url(${imageUrl})`
    : undefined;

  return (
    <>
      <PageHead
        title={intl.formatMessage({
          defaultMessage: 'Sistemi Informativi S.r.l. - An IBM company - Servizi e Soluzioni',
          description: 'Servizi e Soluzioni - Detail - Page title'
        })}
        description={intl.formatMessage({
          defaultMessage: 'Sistemi Informativi S.r.l. - Servizi e Soluzioni',
          description: 'Servizi e Soluzioni - Detail - Page description'
        })}
      />
      <Navbar
        navCssClasses={cn(`${styles.navbarBackground} position-fixed`, {
          [styles.noImgBackground]: !imageUrl,
          [styles.darkNavbarBackground]: darkTheme
        })}
        navLinkCssClasses={styles.navItem}
        serviceCategories={serviceCategories}
        technologyCategories={technologyCategories}
      />
      <main role="main">
        <div
          className={`container-fluid ${styles.hero} snf-bg-repeat-no-repeat snf-bg-position-center `}
          style={{
            backgroundImage,
            backgroundColor: darkTheme ? 'black' : 'white'
          }}
        >
          <div className={`row ${styles.wrapper}`}>
            <div className={`col-auto pt-3 ${styles.padding}`}>
              <Link to={link} className={cn(styles.arrow, { [styles.darkArrow]: darkTheme })}>
                <SVG />
              </Link>
            </div>
            <div
              className={cn(`col-12 pt-3 pt-md-0 ${styles.padding} col-lg-7 snf-text-color-black`, {
                'snf-text-color-white': darkTheme
              })}
            >
              <div className="row mb-2">
                <div className={`col-12 ${styles.padding} snf-font-32 snf-font-w6 ${styles.title}`}>
                  {getObjectValue(translations, 'title', '')}
                </div>
              </div>
              <div className="row mb-3">
                <div
                  className={`col-12 ${styles.padding} snf-font-20 snf-font-w6 ${styles.subtitle}`}
                >
                  {getObjectValue(translations, 'subtitle', '')}
                </div>
              </div>
              <div className="row mb-3">
                <div className={`col-12 ${styles.padding} snf-font-16 ${styles.paragraph}`}>
                  <div
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: translations.paragraph }}
                  />
                </div>
              </div>
              <AdditionalContentAccordionGroup
                translations={translations}
                darkTheme={darkTheme}
                id="detail"
              />
              <div className="row">
                <div className={`col-auto p-0 ${styles['carousel-container']}`}>
                  <GenericSlider
                    autoPlay
                    currentSlideIndex={visibleSlideNumber}
                    slides={mappedSlides}
                    onSlideChange={setVisibleSlideNumber}
                    cyclic
                    hidePositionIndicators
                    className="p-0"
                  />
                </div>
              </div>
            </div>
          </div>
          <ScrollToTop />
        </div>
      </main>
    </>
  );
};

Dettaglio.displayName = 'Dettaglio ';
export { Dettaglio };
